import { Container } from "unstated";

import { store } from "./browserStore";

const STORAGE_KEY = "layout.collapsed";

class LayoutContainer extends Container {
  state = { collapsed: store.get(STORAGE_KEY, false) };
  collapse = (collapsed) => {
    store.set(STORAGE_KEY, collapsed);
    this.setState({ collapsed });
  };
  isCollapsed = () => this.state.collapsed;
}

export default LayoutContainer;
